import React from "react";

import Aos from "aos";
import { useEffect } from "react";
import { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };
  return (
    <p className="text">
      {isReadMore ? text.slice(0, 300) : text}
      <button>
        <span
          onClick={toggleReadMore}
          className="read-or-hide text-[#1639d2] ml-1"
        >
          {isReadMore ? "...read more" : " show less"}
        </span>
      </button>
    </p>
  );
};

export const Solution = (props) => {
  useEffect(() => {
    Aos.init({ duration: 600 });
  }, []);
  return (
    <div id="Solution" className=" overflow-hidden">
      {/* <Fade cascade damping={0.1}> */}
      <div className="bg-[#002e5b]  flex justify-between xs:px-[20px] md:px-[100px] items-center">
        <div className="text-white">
          <p className="xs:text-[9px] md:text-[17px] ">
            We are the Business Patner you are Looking for:
          </p>
        </div>
        <div className="py-2">
          <a href="https://matrix-resources-limited-kenya.business.site/">
            <button className="rounded-sm p-2 bg-[#ffe100] xs:text-[9px] md:text-[17px]">
              CONTACT NOW
            </button>
          </a>
        </div>
      </div>
      <div className="">
        <div
          className="text-center bg-white pt-8 "
          data-aos="fade-up"
          data-aos-delay="100"
        >
          <h1 className="text-[#002e5b] py-4 ">Our Services</h1>
          <h2 className="text-[#002e5b] py-4 ">
            We provide quality goods and service to our clients in a timely
            manner
          </h2>
        </div>
        <div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3  pt-5 px-[100px] justify-center">
            <div
              className="flex flex-col items-center "
              data-aos="fade-up"
              data-aos-delay="50"
            >
              <div className="py-2">
                <div className=" object-cover h-[200px] w-[300px]">
                  <img
                    className="object-cove h-[200px] w-[300px] rounded-t-lg"
                    src="/images/constructionworks.jpeg"
                    alt=""
                  />
                </div>
                <div className=" w-[300px] relative">
                  <h1 className="text-[#002e5b] py-4 text-[17px]">
                    CONSTRUCTIONS WORKS.
                  </h1>
                  <p className=" text-[13px] text-justify">
                    <ReadMore>
                      Matrix Resources Limited is experienced in handling
                      construction projects of various sizes and complexities.
                      Their expertise lies in earthworks and the construction of
                      steel structure warehouses with foundations and go-downs.
                      Additionally, they excel in building works, including
                      constructing multi-story buildings and supportive
                      amenities. The company upholds the highest standards of
                      quality and follows industry best practices to ensure the
                      successful completion of construction projects.
                    </ReadMore>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="flex flex-col items-center"
              data-aos="fade-up"
              data-aos-delay="80"
            >
              {" "}
              <div className="py-2">
                <div className="h-[200px] w-[300px] object-cover">
                  <img
                    className="object-cover h-[200px] w-[300px] rounded-t-lg"
                    src="/images/Healthservices.jpg"
                    alt=""
                  />
                </div>
                <div className="w-[300px]">
                  <h1 className="text-[#002e5b] py-4 text-[17px]">HEALTH</h1>

                  <p className=" text-[13px] text-justify">
                    <ReadMore>
                      Matrix Resources Limited is a reliable supplier of
                      healthcare equipment and supplies. They offer a
                      comprehensive range of medical products, including
                      laboratory machines, surgical equipment, consumables, and
                      reagents. Their products play a crucial role in supporting
                      healthcare facilities and laboratories, aiding medical
                      professionals in their diagnostic and treatment
                      procedures. Matrix Resources Limited ensures the
                      availability of high-quality healthcare equipment to meet
                      the demands of the ever-evolving healthcare industry.
                    </ReadMore>
                  </p>
                </div>
              </div>
            </div>
            <div
              className="flex flex-col items-center "
              data-aos="fade-up"
              data-aos-delay="100"
            >
              <div className="py-2">
                <div className=" object-cover h-[200px] w-[300px]">
                  <img
                    className="object-cove h-[200px] w-[300px] rounded-t-lg"
                    src="/images/fuel.png"
                    alt=""
                  />
                </div>
                <div className="w-[300px]">
                  <h1 className="text-[#002e5b] py-4 text-[17px]">
                    FUEL SUPPLY.
                  </h1>
                  <p className=" text-[13px] text-justify">
                    <ReadMore>
                      As an independent reseller of fuel, Matrix Resources
                      Limited is a key player in the petroleum industry. Through
                      supply agreements with major oil companies, they provide a
                      wide range of petroleum products. Their offerings include
                      diesel, petrol, paraffin, heavy fuel oil (+0), liquefied
                      petroleum gas (LPG), gas mixtures, jet fuel, and aviation
                      gasoline. With their supply capabilities, Matrix Resources
                      Limited serves clients not only in Kenya but also across
                      different African countries, ensuring a reliable and
                      consistent supply of petroleum products.
                    </ReadMore>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3  pt-5 px-[100px] justify-center ">
            <div
              className="py-2 pt-10 w-full flex flex-col items-center"
              data-aos="fade-up"
              data-aos-delay="50"
            >
              <div className="h-[200px] w-[300px] object-cover">
                <img
                  className="object-cover h-[200px] w-[300px] rounded-t-lg"
                  src="/images/IT_PRODUCT.jpg"
                  alt=""
                />
              </div>
              <div className=" w-[300px] relative">
                <h1 className="text-[#002e5b] py-4 text-[17px]">IT PRODUCTS</h1>
                <p className=" text-[13px] text-justify">
                  <ReadMore>
                    Matrix Resources Limited also specializes in providing IT
                    solutions. They supply a diverse range of electronic
                    products, including desktop computers, printers, toners,
                    office solutions, and stationery. Additionally, the company
                    offers telecommunication equipment, laptops, and phones to
                    meet the technological needs of its clients. With their
                    comprehensive IT solutions, Matrix Resources Limited assists
                    businesses in optimizing their operations and staying
                    technologically up-to-date.
                  </ReadMore>
                </p>
              </div>
            </div>

            <div
              className="py-2 pt-10 flex flex-col items-center"
              data-aos="fade-up"
              data-aos-delay="80"
            >
              <div>
                <div className=" object-cover h-[200px] w-[300px]">
                  <img
                    className="object-cover h-[200px] w-[300px] rounded-t-lg"
                    src="/images/Gen_supply.jpg"
                    alt=""
                  />
                </div>
                <div className="w-[300px]">
                  <h1 className="text-[#002e5b] py-4 text-[17px]">
                    GENERAL SUPPLY.
                  </h1>
                  <p className=" text-[13px] text-justify">
                    <ReadMore>
                      By focusing on quality and attention to detail, the
                      company meets its client's specific needs and
                      requirements. Matrix Resources Limited prides itself on
                      its commitment to excellence, professionalism, and
                      customer satisfaction across all sectors they operate
                      in. Their comprehensive range of services and products,
                      from construction to healthcare equipment supplies,
                      petroleum product sales, IT solutions, and more,
                      positions them as a reliable and trusted partner for
                      clients in Kenya and beyond.
                    </ReadMore>
                  </p>
                </div>
              </div>


            </div>



            <div
              className="py-2 pt-10 flex flex-col items-center"
              data-aos="fade-up"
              data-aos-delay="80"
            >
              <div>
                <div className=" object-cover h-[200px] w-[300px]">
                  <img
                    className="object-cover h-[200px] w-[300px] rounded-t-lg"
                    src="/images/Cargo_handling.jpg"
                    alt=""
                  />
                </div>
                <div className="w-[300px]">
                  <h1 className="text-[#002e5b] py-4 text-[17px]">
                    CARGO HANDLING.
                  </h1>
                  <p className=" text-[13px] text-justify">
                    <ReadMore>
                      At Matrix Resources Limited, we understand the critical importance of efficient cargo handling in the logistics chain. Our cargo handling services are designed to streamline the process of loading and unloading goods, ensuring smooth transitions between transportation modes and minimizing the risk of damage or delays.

                      Our expert team is trained in the proper handling techniques for a wide variety of cargo types, from fragile and perishable goods to heavy machinery and oversized items. We utilize industry-leading equipment and tools to facilitate safe and efficient handling, adhering to stringent safety protocols to protect both the cargo and personnel involved.

                      Whether it's at ports, warehouses, or distribution centers, we ensure that each step of the cargo handling process is meticulously managed to optimize efficiency and minimize turnaround times. From proper packaging and labeling to careful loading and secure stowing, our goal is to ensure that your goods are handled with the utmost care and attention to detail.

                      By entrusting your cargo handling needs to Matrix Resources Limited, you can rest assured that your shipments will be handled with professionalism, precision, and reliability every step of the way. Our commitment to excellence in cargo handling is backed by years of industry experience and a dedication to customer satisfaction.
                    </ReadMore>
                  </p>
                </div>
              </div>


            </div>

          </div>


          <div className="grid md:grid-cols-2 lg:grid-cols-3  pt-5 px-[100px] justify-center ">
            <div
              className="py-2 pt-10 w-full flex flex-col items-center"
              data-aos="fade-up"
              data-aos-delay="50"
            >
              <div className="h-[200px] w-[300px] object-cover">
                <img
                  className="object-cover h-[200px] w-[300px] rounded-t-lg"
                  src="/images/Cargo_transport.jpg"
                  alt=""
                />
              </div>
              <div className=" w-[300px] relative">
                <h1 className="text-[#002e5b] py-4 text-[17px]">LOOSE CARGO TRANSPORTATION.</h1>
                <p className=" text-[13px] text-justify">
                  <ReadMore>
                    Matrix Resources Limited specializes in providing tailored transportation solutions for loose cargo, offering secure and efficient shipping services to meet your specific logistical requirements. Whether you need to transport bulk materials, irregularly shaped items, or goods that do not fit traditional packaging standards, we have the expertise and resources to ensure safe and reliable delivery.

                    Our team of logistics professionals meticulously plans and coordinates each loose cargo shipment, considering factors such as cargo size, weight, and fragility to determine the most suitable transportation method. Whether by truck, air freight, or sea freight, we leverage our extensive network of carriers and logistics partners to provide flexible and cost-effective transportation options tailored to your needs.

                    With a focus on safety and efficiency, we employ industry-leading practices and equipment to secure and protect loose cargo during transit. From specialized loading and securing techniques to comprehensive insurance coverage, we take every precaution to minimize the risk of damage or loss throughout the transportation process.

                    At Matrix Resources Limited, we understand the importance of timely and dependable transportation services in today's fast-paced business environment. That's why we prioritize reliability and customer satisfaction, ensuring that your loose cargo reaches its destination on time and in pristine condition. Trust us to handle your loose cargo transportation needs with professionalism, expertise, and a commitment to excellence.
                  </ReadMore>
                </p>
              </div>
            </div>

          </div>




        </div>
      </div>
      {/* </Fade> */}
    </div>
  );
};
